var map = {
	"./BuildingWorksSvg.vue": 7897,
	"./ConsultingSvg.vue": 8155,
	"./InstallationWorksSvg.vue": 472,
	"./RenovationWorksSvg.vue": 5126,
	"./SprayMethodsSvg.vue": 7916
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9267;